export const defaultMetaTags = {
  title:
    'A software solution made by pet lovers, for pet lovers. We call it Pawzr.',
  site_name:
    'Pets are our world too, Pawzr is where you can keep it all organized | Pawzr',
  description:
    'A software solution made by pet lovers, for pet lovers. We call it Pawzr.',
  imageUrl: 'https://pawzr.s3.us-east-2.amazonaws.com/pawzr_logo.jpeg',
};
